var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.ready)?_c('div',{staticClass:"app-container"},[_c('portal-target',{attrs:{"name":"sc-modal","transition":"fade-in-transition"}}),_c('sc-nav'),_c('router-view')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }